/*
 * @Description: index.js
 * @Autor: kangpeng
 * @Date: 2020-04-17 11:51:43
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-06-03 17:11:17
 */
import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import BScroll from "better-scroll";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
    }
})

export default router